import api from '@/api'

import * as types from './globalMutations-types'

const modelNames = {
  improvementIdea: 'revs',
  problemSolving: 'problem-solving',
  quickAction: 'quick-actions',
}

function handleError(context, err) {
  context.dispatch('hideLoader')
  return err
}

export default {
  showLoader(context) {
    context.commit(types.LOADER_STATUS, {
      showing: true,
    })
  },

  hideLoader(context) {
    context.commit(types.LOADER_STATUS, {
      showing: false,
    })
  },

  showError(context, message) {
    context.commit(types.ALERT_STATUS, {
      status: true,
      type: 'danger',
      message: message,
      keepAlive: false,
    })
  },

  showWarning(context, message) {
    context.commit(types.ALERT_STATUS, {
      status: true,
      type: 'warning',
      message: message,
      keepAlive: false,
    })
  },

  showSuccess(context, message) {
    context.commit(types.ALERT_STATUS, {
      status: true,
      type: 'success',
      message: message,
      keepAlive: false,
    })
  },

  showAlert(context, payload) {
    context.commit(types.ALERT_STATUS, {
      status: payload.status,
      type: payload.type,
      message: payload.message,
      keepAlive: payload.keepAlive || false,
    })
  },

  hideAlert(context) {
    context.commit(types.ALERT_STATUS, {
      status: false,
      type: '',
      message: '',
    })
  },

  handleHTTPError(context, error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      context.dispatch('showError', error.response.data.message)
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      context.dispatch('showError', error.request)
    } else {
      // Something happened in setting up the request that triggered an Error
      context.dispatch('showError', error.message)
    }

    context.dispatch('hideLoader')
  },

  setLanguage(context, { language }) {
    context.commit(types.LANGUAGE, { language })
  },

  displayDeleteModal(context, displayDeleteModal) {
    context.commit(types.DISPLAY_DELETE_MODAL, {
      displayDeleteModal,
    })
  },

  setOrganizationCurrency(context, payload) {
    context.commit(types.SET_ORGANIZATION_CURRENCY, {
      currency: payload.currency,
    })
  },

  setOrganizationTheme(context, payload) {
    context.commit(types.SET_ORGANIZATION_THEME, {
      theme: payload.theme,
    })
  },

  setAnonymousTracking(context, payload) {
    context.commit(types.ENABLE_ANONYMOUS_TRACKING, Boolean(payload))
  },

  getRevById(context, { organizationId, revId, revType }) {
    if (revType === 'improvementIdea') {
      return api.rev.getById(organizationId, revId).then(({ data: rev }) => {
        return rev
      })
    } else if (revType === 'problemSolving') {
      return api.problemsolving
        .getById(organizationId, revId)
        .then(({ data: rev }) => {
          return rev
        })
    } else if (revType === 'quickAction') {
      return api.quickaction
        .getById(organizationId, revId)
        .then(({ data: rev }) => {
          return rev
        })
    }
  },

  likeItem(context, { organizationId, revId, revType }) {
    const modelName = modelNames[revType]
    return api.like
      .add(organizationId, modelName, revId)
      .then(response => {
        return response
      })
      .catch(handleError)
  },

  unlikeItem(context, { organizationId, revId, revType }) {
    const modelName = modelNames[revType]
    return api.like
      .remove(organizationId, modelName, revId)
      .then(response => {
        return response
      })
      .catch(handleError)
  },
}
